import styled from 'styled-components';
import {
  BreakPoint,
  Color,
  Font,
  FontSize,
} from '../../../../phase2/survey/asset/styles';

export const StyledWrapper = styled.div(
  props => `
  width: 100%;
  background-color: ${Color.white};
  /*
  desktop / mobile 表示
  display: ${props.desktop ? 'block' : 'none'};
  */
`
);

export const StyledBox = styled.div`
  font-family: ${Font.default};
  line-height: 1.5;
  padding: 16px;
  box-sizing: border-box;
  /*
  max-width: ${BreakPoint.desktop};
  */
  margin: 0 auto;

  * {
    font-family: ${Font.default};
  }
`;

export const StyledMessageBox = styled.div`
  margin-bottom: 25px;
`;

// あなたはこのキャンペーンを家族や友達に薦めたいと思いますか？
export const StyledMessage = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  word-break: break-all;
  text-align: center;
  flex: 1;
`;

export const StyledRadiosBox = styled.div`
  display: flex;
  width: 100%;
  max-width: ${BreakPoint.desktop};
  margin: 0 auto;
`;

export const StyledGuideDiv = styled.div`
  padding: 12px 0 0 0;
  display: flex;
  justify-content: space-between;
  max-width: ${BreakPoint.desktop};
  margin: 0 auto;

  .nps-message {
    font-size: 10px;
    line-height: 1;
    width: 20%;
    text-align: center;
    white-space: nowrap;
  }
`;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/nps/style.js